/**
 * @author: lv.chen3
 * @desc: 折线图组件
 * @date: 2025/6/19
 */
import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useLatest } from 'ahooks';
import useChart from '@gp/hooks/echarts/useChart';

export interface ILegendSelectedChangePayload {
  type: string;
  name: 'legendselectchanged';
  selected: Record<string, boolean>;
}

interface ILineChartProps extends IBaseProps {
  option: IEChartOption;
  onLegendSelectedChange?: (payload: ILegendSelectedChangePayload, ...args: unknown[]) => void;
}

const LineChart: React.FC<ILineChartProps> = (props) => {
  const { style, className, option, onLegendSelectedChange } = props;
  const onLegendSelectedChangeLatest = useLatest(onLegendSelectedChange);

  /**
   * 1、初始化chart实例
   * 2、监听window的resize事件，处理echarts resize
   * 3、echart配置项变化时,更新echart UI
   */
  const { chartNode, setOption, getChartInstance } = useChart({});

  const handleLegendSelectedChange = (payload: ILegendSelectedChangePayload, ...args: unknown[]) => {
    onLegendSelectedChangeLatest.current?.(payload, ...args);
  };

  useEffect(() => {
    const chartInstance = getChartInstance();
    // @ts-ignore
    chartInstance?.on('legendselectchanged', handleLegendSelectedChange);

    setOption(option);

    return () => {
      chartInstance?.off('legendselectchanged', handleLegendSelectedChange);
    };
  }, [option]);

  useEffect(() => {
    const chartInstance = getChartInstance();
    chartInstance?.resize();
  }, [style?.height]);

  return (
    <div
      ref={chartNode}
      style={style}
      className={classnames('dbi-global-view-market-size-line-chart', className)}
    ></div>
  );
};

export default LineChart;
